import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Business } from "../../business/_types/business";
import { Case } from "../../cases/_types/case";


export enum CostLineType {
    Case = "Case",
    SMS = "SMS",
    GoogleGeocodingApi = "GoogleGeocodingApi",
    OpenAI_CaseResume = "OpenAI_CaseResume",
    OpenAI_AudioTranscription = "OpenAI_AudioTranscription",
    Whatsapp = "Whatsapp",
    Api = "Api",
    PBX = "PBX"
}


export class CostLine extends Resource {
    public override type = 'cost-lines';

    @prop()
    public businessId!: string;

    @propObject()
    public business!: Business;

    @prop()
    public caseId!: string;

    @propObject()
    public case!: Case;

    @prop()
    public date: Date = new Date();

    @prop()
    public description!: string;

    @prop()
    public price!: number;

    @prop()
    public _type: CostLineType  = CostLineType.Case;
    

}